import Carousel from '../@tix02/component/Carousel';


/*
 * Carousels 
 */
export default () => {
	const carousels = Array.from(document.querySelectorAll('.carousel'));
	carousels.forEach(c => {
		new Carousel(c, {
			progressBar: {
				enabled: true,
			},
			durations: {
				standby: 4000,
			},
		});
	});
};